import { render } from "./planeOrder.vue?vue&type=template&id=c900a61c"
import script from "./planeOrder.vue?vue&type=script&lang=js"
export * from "./planeOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__